import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function ToolCallReadDocumentIcon(props: SimpleIconInterface): JSX.Element {
  const { stroke = IconColors.DarkGrey, ...rest } = props;

  return (
    <SimpleIcon {...rest} stroke={stroke} viewBoxDimensions="0 0 24 24">
      <path
        d="M22.5 21.75a1.5 1.5 0 0 1 -1.5 1.5H3a1.5 1.5 0 0 1 -1.5 -1.5V2.25A1.5 1.5 0 0 1 3 0.75h15.045a1.5 1.5 0 0 1 1.048 0.426l2.954 2.883a1.5 1.5 0 0 1 0.453 1.074Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="m6.045 8.25 12 0"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="m6.045 12.75 12 0"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="m6.045 17.25 6 0"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </SimpleIcon>
  );
}
